import ky from 'ky';
import { getCgAuthHeaders, isCgTestingEnabled } from "../../utils/cgTesting";


let doprint = false;
// let doprint = true;


export const fetchRemoteAsset = async (url, onProgress) => {
	const isUgcAsset = url.includes("choirplayerugc.s3.amazonaws.com");
	const fetchUrl = isUgcAsset
	  ? `${url}${url.includes("?") ? "&" : "?"}cb=${Date.now()}`
	  : url;

	if (doprint) console.log('fetchRemoteAsset url = ', url);

	if (isUgcAsset) {
	  if (doprint) console.log("[UGC] fetchRemoteAsset FRESH fetchUrl = ", fetchUrl);
	}

	// pgw 05-nov-2025
    const progressHandler = (progress) => {
        // const progressPercentage = ((progress.loaded/progress.total) * 100).toFixed(0);
        onProgress(progress.percent * 100);
    }

	// pgw 20-apr-2023
	// Set timeout to 60 seconds (rather than default, which is 10 seconds)

    const headers = isCgTestingEnabled()
      ? getCgAuthHeaders()
      : isUgcAsset
        ? {}
        : { 'x-auth-token': 'AUTH_TOKEN' };

    const response = {
        data: await ky.get(fetchUrl, {
      		headers,
            cache: "no-store",
            onDownloadProgress: progressHandler,
			timeout: 60000
        }).arrayBuffer()
    }

    return response;
}

